import { webApi } from '@mi-front/api-clients';
import { Segment } from '@mi-front/core';

export type Fragment = webApi.GetFragmentDto;

export type FragmentChunk = webApi.GetFragmentChunkDto;

// type BaseCreateFragmentData = CreateFragmentDto & {
//   doExternalExport?: boolean;
//   platformUpload?: PartialRecord<
//     SocialPlatformId,
//     {
//       enabled: boolean;
//       config?: unknown;
//     }
//   >;
// };

export type CreateDefaultFragmentData = webApi.CreateFragmentDto & Pick<Fragment, 'from' | 'to'>;

/** Joint create payload: chunks must match the BFF create DTO, not GET fragment chunks. */
export type CreateJointFragmentData = Omit<webApi.CreateFragmentDto, 'chunks'> & {
  chunks: NonNullable<webApi.CreateFragmentDto['chunks']>;
};

export type DisplayableChunk = FragmentChunk & {
  color: string;
  segments: readonly Segment[];
};

export type DisplayableJointFragment = {
  chunks: DisplayableChunk[];
};

export function isSavedFragment(f: Fragment | DisplayableJointFragment): f is Fragment {
  return !!(f as Fragment).id;
}
